module.exports = __webpack_public_path__ + "static/media/delivery-truck.2ccb7bb8.svg";